export default function loadCommonAdmitadScript() {
  const oldScript = document.getElementById('common-admitAd-script');
  if (oldScript) {
    oldScript.remove();
  }

  const script = document.createElement('script');
  script.id = 'common-admitAd-script';
  script.src = 'https://www.artfut.com/static/tagtag.min.js?campaign_code=9d8c5dd941';
  script.async = true;
  document.head.appendChild(script);

  const scr = document.createElement('script');
  scr.type = 'text/javascript';
  scr.setAttribute('data-inline-script', 'common-admitAd-script');
  scr.textContent = `
      var cookie_name = 'admitAd_cookie';
      var days_to_store = 30;
      var admitAd_cookie_value = 'admitad';
      var channel_name = 'utm_source';
      getSourceParamFromUri = function() {
        var pattern = channel_name + '=([^&]+)';
        var re = new RegExp(pattern);
        return (re.exec(document.location.search) || [])[1] || '';
      };
  
      getSourceCookie = function() {
        var matches = document.cookie.match(new RegExp(
          '(?:^|; )' + cookie_name.replace(/([.$?*|+^])/g, '\\$1') + '=([^;]*)'
        ));
        return matches ? decodeURIComponent(matches[1]) : undefined;
      };
  
      setSourceCookie =  function() {
        var param = getSourceParamFromUri();
        var params = (new URL(document.location)).searchParams;
        if (!params.get(channel_name) && params.get('gclid')) { param = 'google' }
        else if (!params.get(channel_name) && params.get('fbclid')) { param = 'facebook' }
        else if (!params.get(channel_name) && params.get('cjevent')) { param = 'cj' }
        else if (!param) { return; }
        var period = days_to_store * 60 * 60 * 24 * 1000;
        var expiresDate = new Date((period) + +new Date);
        var cookieString = cookie_name + '=' + param + '; path=/; expires=' + expiresDate.toGMTString();
        document.cookie = cookieString;
        document.cookie = cookieString + '; domain=.' + location.host;
      };
  
      setSourceCookie();
    `;
  document.head.appendChild(scr);
}
